import { AssetsService } from "app/services/AssetsService";

const SecondaryHomePageHeaderImageUrl = AssetsService.assetUrl("/images/secondary-home-page-header-light.png");

export const siteAuditHomepagePreview = [
    {
        image: "/images/site-audit/files/imagePreviewPicture1.png",
        title: "digitalsuite.site_audit.homepage.location1.title",
        descriptions: [
            "digitalsuite.site_audit.homepage.location1.subtitle1",
            "digitalsuite.site_audit.homepage.location1.subtitle2",
        ],
    },
    {
        image: "images/site-audit/files/imagePreviewPicture2.png",
        title: "digitalsuite.site_audit.homepage.location2.title",
        descriptions: [
            "digitalsuite.site_audit.homepage.location2.subtitle1",
            "digitalsuite.site_audit.homepage.location2.subtitle2",
            "digitalsuite.site_audit.homepage.location2.subtitle3",
        ],
    },
];
